import { FC } from 'react';

import { IonTitle } from '@ionic/react';

import { Logo } from '../../Logo/Logo';

import styles from './HeaderLogo.module.scss';

export const HeaderLogo: FC = () => {
  return (
    <IonTitle className={styles.root}>
      <Logo height={22} />
    </IonTitle>
  );
};
